import React from 'react';
import PropTypes from 'prop-types';
import WarningModal from 'chameleon/ui-stack/ui/modals/warning-modal';

const TimedAssignmentWarningModal = (props) => {
  const { allowHardTimerFF, isHardTimer, timer, onSuccess, onClose } = props;

  const warningText = `${isHardTimer ? 'This quiz will automatically submit when the timer expires! ' : ''}Check that you have enough time to complete this assignment.`;

  return (
    <WarningModal
      size="tiny"
      title="This Is A Timed Assignment"
      warning={warningText}
      content={{
        btnPrimary: 'Start Assignment',
        btnSecondary: 'Cancel',
      }}
      onSuccess={onSuccess}
      onClose={onClose}
    >
      {allowHardTimerFF ? (
        isHardTimer ? (
          <p>
            This assignment has a strict time limit of <b>{timer}</b> minutes
            and your assignment will be submitted once the timer expires. Once
            you start it, you will not be able to pause the timer.
          </p>
        ) : (
          <p>
            This assignment has a time limit of <b>{timer}</b> minutes, however,
            your teacher has disabled the strict time limit for this assignment
            and it will NOT be automatically submitted when the timer expires.
            Once you start it, you will not be able to pause the timer.
          </p>
        )
      ) : (
        <p>
          You will need <b>{timer}</b> minutes to complete this assignment. Once
          you start it, you will not be able to pause the timer.
        </p>
      )}
    </WarningModal>
  );
};

TimedAssignmentWarningModal.propTypes = {
  timer: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TimedAssignmentWarningModal;
